var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"fzf"},[_c('div',{staticClass:"fzfbox"},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('router-link',{staticClass:"break-btn",attrs:{"to":{path:'/'}}},[_vm._v("\n        Go to homepage!\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bc346af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":["src","xlink:href"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/shared/404.vue
// module id = 7p9a
// module chunks = 1